module.exports = __webpack_public_path__ + "static/media/aquaponics.2afdf385.png";